import { R } from '@/config/siteRoutes';

/**
 * 语言相关路由辅助：
 * - 英文：lang=en（站点默认）
 * - 中文：lang=zh 或无 lang
 */
export function isEnglishRoute(route) {
  if (!route || !route.query) return false;
  if (route.query.lang === 'zh') return false;
  return route.query.lang === 'en';
}

export function withLang(query = {}, route) {
  const next = { ...query };
  if (isEnglishRoute(route)) {
    next.lang = 'en';
  } else if (route && route.query && route.query.lang === 'zh') {
    next.lang = 'zh';
  } else {
    delete next.lang;
  }
  return next;
}

export function langLink(path, query = {}, route) {
  return {
    path,
    query: withLang(query, route)
  };
}

/** 站点首页（中英文均为反无人机首页） */
export function siteHomeLink(route) {
  if (isEnglishRoute(route)) {
    return { path: R.HOME, query: { lang: 'en' } };
  }
  if (route && route.query && route.query.lang === 'zh') {
    return { path: R.HOME, query: { lang: 'zh' } };
  }
  return R.HOME;
}
